import {
  Stethoscope,
  Syringe,
  Activity,
  Waves,
  ClipboardCheck,
  Brain,
  Zap,
  Wind,
  Compass,
  HeartPulse,
  Network,
  Moon,
  Dumbbell,
  Sparkles,
  CircleDot,
} from "lucide-react";

const MAP = {
  Stethoscope,
  Syringe,
  Activity,
  Waves,
  ClipboardCheck,
  Brain,
  Zap,
  Wind,
  Compass,
  HeartPulse,
  Network,
  Moon,
  Dumbbell,
  Sparkles,
};

export function getIcon(name) {
  return MAP[name] || CircleDot;
}
